(function () {
  // Evita doppie inizializzazioni
  if (window.__insurefulI18NLoaded) return;
  window.__insurefulI18NLoaded = true;

  // === 1) Dizionario traduzioni (IT -> altre lingue) ===
  const I18N = {
    en: {
      "Spedizione assicurata": "Shipping protection",
      "Deselezionando la protezione della spedizione, non siamo responsabili per articoli smarriti, danneggiati o rubati":
        "By deselecting shipping protection, we are not responsible for lost, damaged, or stolen items",
      "Versicherung-on": "Protection on",
      "Versicherung-off": "Protection off"
    },
    de: {
      "Spedizione assicurata": "Versandversicherung",
      "Deselezionando la protezione della spedizione, non siamo responsabili per articoli smarriti, danneggiati o rubati":
        "Wenn der Versandschutz abgewählt wird, haften wir nicht für verlorene, beschädigte oder gestohlene Artikel",
      "Versicherung-on": "Schutz an",
      "Versicherung-off": "Schutz aus"
    },
    fr: {
      "Spedizione assicurata": "Assurance expédition",
      "Deselezionando la protezione della spedizione, non siamo responsabili per articoli smarriti, danneggiati o rubati":
        "En désélectionnant la protection d’expédition, nous ne sommes pas responsables des articles perdus, endommagés ou volés",
      "Versicherung-on": "Protection activée",
      "Versicherung-off": "Protection désactivée"
    },
    es: {
      "Spedizione assicurata": "Protección de envío",
      "Deselezionando la protezione della spedizione, non siamo responsabili per articoli smarriti, danneggiati o rubati":
        "Al desactivar la protección de envío, no somos responsables por artículos perdidos, dañados o robados",
      "Versicherung-on": "Protección activada",
      "Versicherung-off": "Protección desactivada"
    }
  };

  // === 2) Lingua corrente da <html lang> (funziona anche senza /en/ nell’URL) ===
  const state = {
    lang: null,
    map: null,
    container: null,
    moContainer: null,
    moWidget: null,
    moLang: null
  };

  const getLang = () => {
    const raw = (document.documentElement.getAttribute('lang') || 'it').toLowerCase();
    return raw.split('-')[0]; // es. "en-GB" -> "en"
  };

  function translateNode(root) {
    if (!root || !state.map) return;

    const skip = (el) => el && (el.closest('.notranslate') || el.closest('.transcy-money'));

    const srcStrings = Object.keys(state.map);
    if (!srcStrings.length) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        const t = (node.nodeValue || '').trim();
        if (!t) return NodeFilter.FILTER_REJECT;
        if (skip(node.parentElement)) return NodeFilter.FILTER_REJECT;
        return srcStrings.includes(t) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    const toPatch = [];
    while (walker.nextNode()) toPatch.push(walker.currentNode);

    toPatch.forEach(node => {
      const original = node.nodeValue.trim();
      const translated = state.map[original];
      if (translated) node.nodeValue = node.nodeValue.replace(original, translated);
    });

    root.querySelectorAll('img[alt], [title]').forEach(el => {
      if (!skip(el)) {
        if (el.hasAttribute('alt') && state.map[el.alt]) el.alt = state.map[el.alt];
        if (el.hasAttribute('title') && state.map[el.title]) el.title = state.map[el.title];
      }
    });
  }

  function translateAll() {
    if (!state.container || !state.map) return;
    translateNode(state.container);
  }

  function setupWidgetObserver() {
    if (!state.container || state.moWidget) return;
    state.moWidget = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'childList') {
          m.addedNodes.forEach(n => { if (n.nodeType === 1) translateNode(n); });
        } else if (m.type === 'characterData') {
          translateNode(m.target.parentNode);
        }
      }
    });
    state.moWidget.observe(state.container, { childList: true, subtree: true, characterData: true });
  }

  function findContainerAndHook() {
    state.container = document.querySelector('#insureful-container');
    if (state.container) {
      translateAll();
      setupWidgetObserver();
    }
  }

  function setupContainerObserver() {
    if (state.moContainer) return;
    state.moContainer = new MutationObserver(() => {
      if (!state.container) findContainerAndHook();
    });
    state.moContainer.observe(document.body, { childList: true, subtree: true });
  }

  function applyLang(newLang) {
    state.lang = newLang;
    state.map = I18N[newLang] || null; // se IT o non mappata -> null
    translateAll();
  }

  function setupLangObserver() {
    if (state.moLang) return;
    state.moLang = new MutationObserver(() => {
      const l = getLang();
      if (l !== state.lang) applyLang(l);
    });
    state.moLang.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  }

  function start() {
    applyLang(getLang());
    setupLangObserver();
    findContainerAndHook();
    setupContainerObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
